import React from "react";
import PageLoader from "@/components/common/PageLoader";

const RouteLoader: React.FC = () => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
            <PageLoader minHeight="min-h-full" />
        </div>
    );
};

export default RouteLoader;
